import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Icon, Link, Text } from 'bsd-global-nav-design-ui';

import { DataContext } from 'context/data/DataContextProvider';
import { AccountManagerContext } from 'context/data/AccountManagerProvider';
import { getCurrentAccount } from 'utils/util';

const baseClass = 'bsd-orion-cbm-sites-modal';

const SiteDetails = ({ site, addressLabel }) => {
  const { addressLine1, addressLine2, city, state, zipCode } =
    site.siteAddress ?? {};

  // Filter out if any value is null or undefined or empty string
  const addressLine3 =
    `${[city, state].filter(Boolean).join(', ').trim()}` + `${zipCode || ''}`;
  return (
    <div className={`${baseClass}-site`} key={site.siteId}>
      <Link isExternal to={site.url}>
        {site.siteName}
        <Icon
          className={`${baseClass}-icon`}
          display="inline"
          modifier="white"
          name="arrow-diagonal"
          size="s"
        />
      </Link>
      {addressLine1 && addressLine3 && (
        <>
          <Text className={`${baseClass}-address-label`}>{addressLabel}</Text>
          <Text className={`${baseClass}-address-value`} element="p">
            {addressLine1}
          </Text>
          {addressLine2 && (
            <Text className={`${baseClass}-address-value`} element="p">
              {addressLine2}
            </Text>
          )}
          <Text className={`${baseClass}-address-value`} element="p">
            {addressLine3}
          </Text>
        </>
      )}
    </div>
  );
};

SiteDetails.propTypes = {
  addressLabel: PropTypes.string.isRequired,
  site: PropTypes.shape({
    siteAddress: PropTypes.shape({
      addressLine1: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zipCode: PropTypes.string,
    }),
    siteId: PropTypes.string.isRequired,
    siteName: PropTypes.string.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

export default function SiteModal() {
  const {
    siteContent,
    userData: { accounts },
  } = useContext(DataContext);
  const { currentAccountId } = useContext(AccountManagerContext);

  const accountDetails = getCurrentAccount(accounts, currentAccountId);

  if (!accountDetails?.cbmSiteDetails?.length || !siteContent) {
    return null;
  }

  return (
    <div className={baseClass}>
      <Text className={`${baseClass}-title`} element="h2">
        {siteContent.title}
      </Text>
      <Text className={`${baseClass}-message`} element="h5">
        {siteContent.message}
      </Text>

      <div className={`${baseClass}-site-container`}>
        {accountDetails.cbmSiteDetails.map((site) => (
          <SiteDetails
            addressLabel={siteContent.addressLabel}
            key={site.siteId}
            site={site}
          />
        ))}
      </div>
    </div>
  );
}
